import { render, staticRenderFns } from "./ProductFilter.vue?vue&type=template&id=3a3d6cc0&scoped=true&"
import script from "./ProductFilter.vue?vue&type=script&lang=ts&"
export * from "./ProductFilter.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFilter.vue?vue&type=style&index=0&id=3a3d6cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d6cc0",
  null
  
)

export default component.exports